<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16YDPY6/tc-custom/9781466884328.jpg?1718152359812" alt="This image is the cover for the book Riddle of the Lost Lover, The Riddle Saga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Riddle of the Lost Lover, The Riddle Saga
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Captain Jack Vespa, hero of <i>The Riddle of Alabaster Royal</i>, returns in another of Patricia Veryan's delightful Regency tales mixing romance and suspense, in <i>The Riddle of the Lost Lover</i>.</b><br/><br/>Veryan's "Best effort yet" (<i>Publishers Weekly</i>), a spirited Regency mixing romance and mystery</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Veryan
      </h2>
      
      <p class="authorDescription body article"><P>Patricia Veryan lives in Kirkland, Washington. She is the author of Riddle of the Lost Lover.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70bdee94